import { Box, TableSortLabel, Tooltip, Typography } from '@mui/material'
import { ExportProps } from 'features/report/report-constants'
import _ from 'lodash'
import { useCallback, useEffect, useState } from 'react'
import { numberFormat } from 'utils/app.utils'

/** TRANSLATION */
import { useTranslation } from 'react-i18next'

import TableRowExport from 'component/Pdf/TableRowExport'
import TableCustom from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'

/** STYLE */
import { colors } from 'constants/theme'
import * as UseStyled from 'features/report/useStyled'

import { SORT_TYPE } from 'constants/common'
import { dateTimeToView } from 'utils/date.utils'
import { UseSnCode } from 'utils/useSnCode'

export interface DoctorFeeComponent {
  page: number
  pageLimit: number
  rowCount: number
  data: any
  dataExport: any
  handleChangeRowsPerPage: (val: any) => void
  handleChangePage: (val: any) => void
  onRequestSort: (sortBy: string, sortType: string) => void
  setSortType: (val: SORT_TYPE) => void
  setSortBy: (val: string) => void
  sortType: string
  sortBy: string
  componentRef: any
  filterTable: any
}

interface DoctorFeeIF {
  qty: number
  totalOriginal: number
  dfBahtOriginal: number
  cfBahtOriginal: number
  overdueDf: number
  overdueCf: number
  amountTransfer: number
  amountTreatmentRight: number
  amountVoucher: number
  amountBalanceBefore: number
  branchCnNumber: string
  cancelBy: string
  cancelRemark: string
  cfAmountCredit: number
  cnNumber: string
  code: string
  createdAt: string
  creditCardFee: number
  creditCost: number
  date: string
  dfAmountCredit: number
  doctorFullName: string
  itemName: string
  overdue: number
  patientFullName: string
  paymentNumber: string
  statusOrder: string
  price: number
  refItemId: number
  remark: string
  staff: string
  total: number
}
export default function BalanceList(props: DoctorFeeComponent) {
  const { t } = useTranslation()

  const [snType, setSnType] = useState(false)

  const handleSnCode = useCallback(() => {
    const fetchData = async () => {
      const sn = await UseSnCode()
      setSnType(sn)
    }

    fetchData()
  }, [snType])

  useEffect(() => {
    handleSnCode()
  }, [])

  const onRequestSort = (sortByVal: string, sortTypeVal: SORT_TYPE) => {
    props.setSortType(sortTypeVal)
    props.setSortBy(sortByVal)
    props.handleChangePage(1)
  }


  const headCells = [
    { id: '1', disablePadding: false, labelKey: 'REPORT.TABLE.DF.#NO', align: 'center', class: 'text-nowrap' },
    { id: '2', disablePadding: false, labelKey: 'วันที่', align: 'center', class: 'text-nowrap' },
    { id: '4', disablePadding: false, labelKey: 'เลขที่ใบเสร็จ', align: 'center', class: 'text-nowrap' },
    { id: '4', disablePadding: false, labelKey: 'สถานะใบเสร็จ', align: 'center', class: 'text-nowrap' },
    { id: '5', disablePadding: false, labelKey: 'รหัสผู้ป่วย', align: 'center', class: 'text-nowrap' },
    { id: '6', disablePadding: false, labelKey: 'รหัสผู้ป่วยในสาขา', align: 'center', class: 'text-nowrap' },
    { id: '7', disablePadding: false, labelKey: 'ชื่อผู้ป่วย', align: 'center', class: 'text-nowrap' },
    { id: '8', disablePadding: false, labelKey: 'ทันตแพทย์', align: 'center', class: 'text-nowrap' },
    { id: '9', disablePadding: false, labelKey: 'Code', align: 'center', class: 'text-nowrap' },
    { id: '10', disablePadding: false, labelKey: 'รายการ', align: 'center', class: 'text-nowrap' },
    { id: '11', disablePadding: false, labelKey: 'ราคาต่อหน่วย', align: 'center', class: 'text-nowrap' },
    { id: '11', disablePadding: false, labelKey: 'จำนวน', align: 'center', class: 'text-nowrap' },
    { id: '11', disablePadding: false, labelKey: 'ราคาค่ารักษา', align: 'center', class: 'text-nowrap' },
    { id: '11', disablePadding: false, labelKey: 'ยอดรวมสุทธิ DF', align: 'center', class: 'text-nowrap' },
    { id: '12', disablePadding: false, labelKey: 'ยอดรวมสุทธิ CF', align: 'center', class: 'text-nowrap' },
    { id: '13', disablePadding: false, labelKey: 'ยอดรวมสุทธิค่ารักษา', align: 'center', class: 'text-nowrap' },
    { id: '13', disablePadding: false, labelKey: 'ค้างชำระ DF', align: 'center', class: 'text-nowrap' },
    { id: '14', disablePadding: false, labelKey: 'ค้างชำระ CF', align: 'center', class: 'text-nowrap' },
    { id: '22', disablePadding: false, labelKey: 'Balance', align: 'center', class: 'text-nowrap' },
    { id: '23', disablePadding: false, labelKey: 'ผู้บันทึก', align: 'center', class: 'text-nowrap' },
    { id: '24', disablePadding: false, labelKey: 'รายละเอียด', width: '350px', align: 'center', class: 'text-wrap' },
    { id: '25', disablePadding: false, labelKey: 'หมายเหตุการยกเลิก', width: '350px !important', align: 'center', class: 'text-wrap' },
    { id: '26', disablePadding: false, labelKey: 'ผู้ยกเลิก', align: 'center', class: 'text-nowrap' }
  ]

  if (!snType) {
    // headCells.splice(3, 1)
  }
  const renderData = (data: any, no: number, exportData: boolean, render: 'data' | 'sum') => {
    if (render === 'data') {
      const doctorFee: DoctorFeeIF = data
      const num = exportData === true ? no + 1 : props.page * props.pageLimit - props.pageLimit + no + 1
      const objRenderData = {
        key: num.toString(),
        id: no.toString(),
        obj: data,
        columns: [
          { option: 'TEXT', align: 'center', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: num, class: 'text-nowrap' },
          { option: 'TEXT', align: 'left', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: dateTimeToView(doctorFee.createdAt), class: 'text-nowrap' },
          { option: 'TEXT', align: 'left', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: doctorFee.paymentNumber, class: 'text-nowrap' },
          { option: 'TEXT', align: 'left', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: t(`REPORT.BILL_STATUS.${doctorFee.statusOrder}`), class: 'text-nowrap' },
          { option: 'TEXT', align: 'left', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: doctorFee.cnNumber, class: 'text-nowrap' },
          { option: 'TEXT', align: 'left', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: doctorFee.branchCnNumber, class: 'text-nowrap' },
          { option: 'TEXT', align: 'left', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: doctorFee.patientFullName, class: 'text-nowrap' },
          { option: 'TEXT', align: 'left', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: doctorFee.doctorFullName, class: 'text-nowrap' },
          { option: 'TEXT', align: 'left', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, format: 'CODE', label: doctorFee.code, class: 'text-nowrap' },
          { option: 'TEXT', align: 'left', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: doctorFee.itemName, class: 'text-nowrap' },
          { option: 'TEXT', align: 'right', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: numberFormat(doctorFee.price, 2), class: 'text-nowrap' },
          { option: 'TEXT', align: 'right', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: numberFormat(doctorFee.qty, 2), class: 'text-nowrap' },
          { option: 'TEXT', align: 'right', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: numberFormat(doctorFee.totalOriginal, 2), class: 'text-nowrap' },
          { option: 'TEXT', align: 'right', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: numberFormat(doctorFee.dfBahtOriginal, 2), class: 'text-nowrap' },
          { option: 'TEXT', align: 'right', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: numberFormat(doctorFee.cfBahtOriginal, 2), class: 'text-nowrap' },
          { option: 'TEXT', align: 'right', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: numberFormat(doctorFee.total, 2), class: 'text-nowrap' },
          { option: 'TEXT', align: 'right', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: numberFormat(doctorFee.overdueDf, 2), class: 'text-nowrap' },
          { option: 'TEXT', align: 'right', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: numberFormat(doctorFee.overdueCf, 2), class: 'text-nowrap' },
          { option: 'TEXT', align: 'right', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: numberFormat(Number(doctorFee.overdueDf) + Number(doctorFee.overdueCf), 2), class: 'text-nowrap' },
          { option: 'TEXT', align: 'left', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: doctorFee.staff, class: 'text-nowrap' },
          {
            option: 'COMPONENT', align: 'left', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16, width: '350px', },
            component: <Tooltip title={doctorFee.remark} placement="top">
              <UseStyled.StylesRemark style={{ wordWrap: 'break-word', width: '350px' }}>{doctorFee.remark || '-'}</UseStyled.StylesRemark>
            </Tooltip>,
            class: 'text-wrap'
          },
          {
            option: 'COMPONENT', align: 'left', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16, width: '350px !important', },
            component: <Tooltip title={doctorFee.cancelRemark} placement="top">
              <UseStyled.StylesRemark style={{ wordWrap: 'break-word', width: '350px' }}>{doctorFee.cancelRemark || '-'}</UseStyled.StylesRemark>
            </Tooltip>,
            class: 'text-wrap'
          },
          { option: 'TEXT', align: 'left', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: doctorFee.cancelBy || '-', class: 'text-nowrap' }
        ]
      }
      // if (!snType) {
      //   objRenderData.columns.splice(3, 1)
      // }
      return <>{(exportData === true && <TableRowExport {...objRenderData} />) || <TableRowCommon {...objRenderData} />}</>
    } else {
      const objRenderData = {
        key: no.toString(),
        id: no.toString(),
        obj: data,
        columns: [
          { option: 'MERGE', align: 'center', colSpan: 9 },
          {
            option: 'TEXT',
            align: 'right',
            style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 },
            label: <Typography sx={{ fontWeight: 500, fontSize: exportData ? 10 : 16 }}>{t('REPORT.TITLE.SUM')}</Typography>,
            class: 'text-nowrap'
          },
          { option: 'TEXT', align: 'right', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: numberFormat(_.sumBy(data, 'price') || 0), class: 'text-nowrap' },
          { option: 'TEXT', align: 'right', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: numberFormat(_.sumBy(data, 'qty') || 0), class: 'text-nowrap' },
          { option: 'TEXT', align: 'right', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: numberFormat(_.sumBy(data, 'totalOriginal') || 0), class: 'text-nowrap' },
          { option: 'TEXT', align: 'right', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: numberFormat(_.sumBy(data, 'dfBahtOriginal') || 0), class: 'text-nowrap' },
          { option: 'TEXT', align: 'right', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: numberFormat(_.sumBy(data, 'cfBahtOriginal') || 0), class: 'text-nowrap' },
          { option: 'TEXT', align: 'right', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: numberFormat(_.sumBy(data, 'total') || 0), class: 'text-nowrap' },
          { option: 'TEXT', align: 'right', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: numberFormat(_.sumBy(data, 'overdueDf') || 0), class: 'text-nowrap' },
          { option: 'TEXT', align: 'right', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: numberFormat(_.sumBy(data, 'overdueCf') || 0), class: 'text-nowrap' },
          { option: 'TEXT', align: 'right', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: numberFormat(_.sumBy(data, (o: any) => { return Number(o.overdueDf) + Number(o.overdueCf) })), class: 'text-nowrap' },
          { option: 'MERGE', align: 'center', colSpan: 4 }
        ],
        classes: 'row-summary'
      }
      return <>{(exportData === true && <TableRowExport {...objRenderData} />) || <TableRowCommon {...objRenderData} />}</>
    }
  }

  return (
    <>
      <Box>
        <UseStyled.ResponsiveReportTable>
          <TableCustom
            rowHeadCell={2}
            tableMinWidth={992}
            page={props.page}
            pageLimit={props.pageLimit}
            sortType={props.sortType}
            sortBy={props.sortBy}
            rowCount={props.rowCount}
            onSort={onRequestSort}
            setPageLimit={props.handleChangeRowsPerPage}
            setPage={props.handleChangePage}
            headCells={headCells}
            rowsData={[
              _.map(props.data, (d: any, index: number) => {
                return renderData(d, index, false, 'data')
              }),
              renderData(props.data, 0, false, 'sum')
            ]}
            customScroll
          />
        </UseStyled.ResponsiveReportTable>
      </Box>
      <div className="print-show" ref={props.componentRef}>
        <ExportData
          headCells={t(`REPORT.REPORT_NAME.BALANCE`)}
          componant={
            <>
              <Box>
                <table>
                  <tr>
                    {props.filterTable.map((filter: any, index: number) => (
                      <TableSortLabel key={index}>
                        {filter.label !== t('REPORT.FILTER.DOCTOR') && (
                          <Box>
                            <td className="mr-2" style={{ textAlign: 'left', fontSize: 16, fontWeight: 800 }}>
                              {t(filter.label)} :{' '}
                            </td>
                            <td style={{ textAlign: 'left', fontSize: 16, fontWeight: 500 }}>{filter.value}</td>
                          </Box>
                        )}
                      </TableSortLabel>
                    ))}
                  </tr>
                </table>
              </Box>
              <UseStyled.Styles className="pt-3">
                <table style={{ tableLayout: 'fixed', borderCollapse: 'collapse', minWidth: '100%', maxWidth: '100%' }}>
                  <thead>
                    <tr>
                      {_.map(headCells, (val: any, index: number) => {
                        return <td style={{ textAlign: val.align, fontSize: 10, fontWeight: 500 }}> {t(val.labelKey)}</td>
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    {_.map(props.dataExport, (d: any, index: number) => {
                      return renderData(d, index, true, 'data')
                    })}
                  </tbody>
                </table>
              </UseStyled.Styles>
            </>
          }
        />
      </div>
    </>
  )
}

export function ExportData(props: ExportProps) {
  return (
    <>
      <div className="large">{props.headCells}</div>
      {props.componant}
    </>
  )
}
